import { styled, x } from '@xstyled/styled-components';
import React from 'react';
import { t } from 'ttag';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Flex } from '~/ui/flex/Flex';
import { HelpPages, useHelpStore } from '../Store';
import { IssueForm } from './IssueForm';

// Keys are in plain english so they can be sent as topic regardless of user language
const topics = [
  { key: 'content_is_offensive', label: t`Content is offensive` },
  { key: 'content_unclear', label: t`Content is not clear` },
  { key: 'grammar_spelling_mistake', label: t`Grammar/spelling mistake` },
  { key: 'technical_issue', label: t`Technical issue` }
];

const HelpBody = styled(Flex)`
  height: auto;
  min-height: 0;
`;

export const ReportIssue = () => {
  const { page, setPage } = useHelpStore();

  if (page !== HelpPages.ReportIssue) return null;

  return (
    <>
      <CloseButton sticky onClick={() => setPage(HelpPages.Root)} />
      <HelpBody variant="list" gap="md">
        <x.h2 id="help-report-issue-title" fontFamily="llama">
          {t`Report an issue`}
        </x.h2>
        <IssueForm topics={topics} recipient="easyllama" />
      </HelpBody>
    </>
  );
};
